import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Star } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const benefits = ['Guía completa de 14 días con menús detallados', 'Lista de compras organizada por departamento', 'Recetas anti-inflamatorias paso a paso', 'Protocolo de drenaje linfático y sueño', 'Autodiagnóstico de inflamación interactivo', 'Acceso de por vida — sin suscripciones'];
export function PricingSection() {
  return <section id="precio" className="py-24 px-6 lg:px-16 bg-darkBrown relative overflow-hidden" data-id="element-275">
      <div className="absolute inset-0 opacity-5" data-id="element-276">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-gold blur-3xl" data-id="element-277" />
        <div className="absolute bottom-0 right-1/4 w-72 h-72 rounded-full bg-gold blur-3xl" data-id="element-278" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-279">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-280">
          <h2 className="text-gold font-medium tracking-widest uppercase text-sm mb-4" data-id="element-281">
            Obtén Tu Copia
          </h2>
          <h3 className="font-serif text-4xl lg:text-5xl text-white font-bold mb-6 leading-tight" data-id="element-282">
            Transforma tu bienestar en{' '}
            <span className="text-gold italic" data-id="element-283">14 días</span>
          </h3>
          <p className="text-xl text-white/70 max-w-2xl mx-auto" data-id="element-284">
            Todo lo que necesitas para desinflamar tu cuerpo, recuperar tu
            energía y sentirte mejor que nunca.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden max-w-lg mx-auto" data-id="element-285">
          <div className="bg-lightGold p-6 text-center border-b border-gold/20" data-id="element-286">
            <div className="flex items-center justify-center gap-1 mb-2" data-id="element-287">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-288" />)}
            </div>
            <p className="text-darkBrown/60 text-sm font-medium" data-id="element-289">
              Más de 2,000 mujeres ya lo están usando
            </p>
          </div>

          <div className="p-8 lg:p-10" data-id="element-290">
            <ul className="space-y-3 mb-8" data-id="element-291">
              {benefits.map((benefit, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-292">
                  <CheckCircle2 className="w-5 h-5 text-gold flex-shrink-0 mt-0.5" data-id="element-293" />
                  <span className="text-darkBrown/80" data-id="element-294">{benefit}</span>
                </li>)}
            </ul>

            <div className="bg-lightGold/50 rounded-2xl p-6 border border-gold/20" data-id="element-295">
              <div className="text-center mb-5" data-id="element-296">
                <div className="flex items-center justify-center gap-3 mb-1" data-id="element-297">
                  <span className="text-darkBrown/40 text-xl line-through font-medium" data-id="element-298">
                    $19.99
                  </span>
                  <span className="bg-gold text-white text-xs font-bold px-2 py-1 rounded-full" data-id="element-299">
                    -68%
                  </span>
                </div>
                <div className="flex items-baseline justify-center gap-1" data-id="element-300">
                  <span className="font-serif text-5xl font-bold text-darkBrown" data-id="element-301">
                    $6.39
                  </span>
                  <span className="text-darkBrown/50 text-base ml-1" data-id="element-302">USD</span>
                </div>
                <p className="text-gold font-semibold text-sm mt-1" data-id="element-303">
                  Oferta especial por tiempo limitado
                </p>
              </div>

              <a id="cta-comprar" href="https://www.plenitudprime.com/cart/48317947248810:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart({
              content_name: 'Metabolismo Dorado',
              value: 6.39,
              currency: 'USD'
            })} className="block w-full text-center bg-gold hover:bg-deepGold text-white py-4 px-4 rounded-full font-semibold text-base sm:text-lg transition-all shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-304">
                Quiero Mi Copia Ahora
              </a>

              <div className="flex items-center justify-center gap-2 mt-4 text-darkBrown/50 text-xs sm:text-sm" data-id="element-305">
                <ShieldCheck className="w-4 h-4 flex-shrink-0" data-id="element-306" />
                <span data-id="element-307">Pago seguro · Garantía de 30 días</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}